import { kilobaApi } from './api';

export interface LeaderboardEntry {
  userId: string;
  username: string;
  score: number;
  rank: number;
  gameType?: string;
  createdAt?: string;
}

export class LeaderboardService {
  /**
   * Get leaderboard for specific game type
   */
  static async getLeaderboard(gameType: string, limit: number = 10): Promise<LeaderboardEntry[]> {
    try {
      const response = await kilobaApi.getLeaderboard(gameType, limit);
      
      if (response.success && response.data) {
        return response.data;
      } else {
        console.error('Failed to get leaderboard:', response.message);
        return this.getMockData();
      }
    } catch (error) {
      console.error('Error getting leaderboard:', error);
      return this.getMockData();
    }
  }

  /**
   * Get mock data for testing/fallback
   */
  private static getMockData(): LeaderboardEntry[] {
    return [
      { userId: '1', username: 'Player1', score: 1500, rank: 1 },
      { userId: '2', username: 'Player2', score: 1200, rank: 2 },
      { userId: '3', username: 'Player3', score: 1000, rank: 3 },
      { userId: '4', username: 'Player4', score: 900, rank: 4 },
      { userId: '5', username: 'Player5', score: 800, rank: 5 },
      { userId: '6', username: 'Player6', score: 700, rank: 6 },
      { userId: '7', username: 'Player7', score: 600, rank: 7 },
      { userId: '8', username: 'Player8', score: 500, rank: 8 },
      { userId: '9', username: 'Player9', score: 400, rank: 9 },
      { userId: '10', username: 'Player10', score: 300, rank: 10 },
    ];
  }
}
